export default __webpack_public_path__ + "static/media/story_img_4.ae5312ca.jpeg";